//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum SamplingCampaignExportType {
  All = 'all',
  Reviews = 'reviews',
  Social = 'social',
  Products = 'products',
  PostSurvey = 'post-survey',
}
